import styled from 'styled-components';
const ErrorTextColor = styled.p`
    color: darkgrey;
`;
const NoDataWrap = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    height: 100%;
`;

export const EmptyDeviceComponent = () => {
    return (
        <div><ErrorTextColor>Device Not Present</ErrorTextColor></div>
    )
}

export const NetworkErrorComponent = () => {
    return (
        <div><ErrorTextColor>Network Is Disconnected</ErrorTextColor></div>
    )
}

export const EmptyStationComponent = () => {
    return (
        <div><p>No Registered</p></div>
    )
}

export const EmptyDataComponent = () => {
    return (
        <NoDataWrap><p>No Data Found</p></NoDataWrap>
    )
}